import { INPUT_UPDATE, INPUT_INITIALIZE } from '../actions/index';

const initialState = {
    p1: '1.7',
    p2: '2.5',
    p3: '380',
    p4: '1270',
    p5: '17',
    time: '18000'
  };

export default function (state = initialState, action) {

    switch (action.type) {
        case INPUT_UPDATE:
          return { ...state, [action.payload.prop]: action.payload.value };
        case INPUT_INITIALIZE:
            return { initialState };
        default:
          return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer-cobiInput.js